export default {
  '--button-default-color': '#303030'
};